module.exports = __webpack_public_path__ + "static/img/cwgl_p4.c6ccbcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/cwgl_p4.png
// module id = usD9
// module chunks = 19